import React from "react";

import t from "../../helpers/t";

// @todo Make functionable

export default () => {
  return (
    <div id="inb-c-main-sort-nav">
      <ul className="inb-tabs">
        <li className="tabs-title small-8 is-active">
          <a href="#">{t("name", null, "capital")}</a>
        </li>
        <li className="tabs-title small-4">
          <a href="#">{t("created_date")}</a>
        </li>
      </ul>
    </div>
  );
};
